import React from 'react';

import { css } from '@emotion/core';

import { useFlags } from 'launchdarkly-react-client-sdk';

import { getColorTint } from '@zego/theme';

import RegularText from '@zego/components/atoms/RegularText';
import Link from '@zego/components/Link';
import Banner from '@zego/components/molecules/Banner';

const UberPromotionBanner = () => {
  const { uberDiscountBanner } = useFlags();

  if (uberDiscountBanner === true) {
    return (
      <Banner testId="uber-promotion-banner">
        <RegularText
          css={{
            textAlign: 'center',
            color: getColorTint('grey', 10),
            fontWeight: 400,
          }}
        >
          Receive a 10% discount on your annual or 30-day policy when you
          insure your electric vehicle.
          <br />
          To buy a policy today call us on +44 20 3885 0120 or start by getting
          your estimate online.{' '}
          <Link
            href="https://cloud.zego-uk.com/EVdiscount"
            target="_blank"
            color={getColorTint('grey', 10)}
            css={css`text-decoration: underline;`}
          >
            T&Cs
          </Link>{' '}
          apply.
        </RegularText>
      </Banner>
    );
  }
  return null;
};

export default UberPromotionBanner;
